module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Bojagi - Ship Flawless UIs in Shorter Cycle Times","short_name":"Bojagi","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/app-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"b0a76b9ff4200101aff48dfaa1c6ef47"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
